import YearGroupReport from './year-group-report.vue'
export default YearGroupReport
